module.exports = __webpack_public_path__ + "media/images/emblems/Baeretswil-blazon-e9344119fa010af1ee612d9084254182.svg";